export const QA_NAME_FILTER_NUMBER_RANGE_MAX = 'filterNumberRangeMax'

export const QA_NAME_FILTER_NUMBER_RANGE_MIN = 'filterNumberRangeMin'
